export const BACKEND_URL_PREFIX = process.env.REACT_APP_URL_API ?? ''
export const REDIRECT_401 = 'test'
